import { Typography } from "@cpj-ai/panel-npm-package";
import { useDisclosure } from "@heroui/react";
import { TermsAndConditionModal } from "./TermsAndConditionModal";

const TermOfUseLabel = () => {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();

  const handleOpenModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onOpen();
  };

  return (
    <>
      <TermsAndConditionModal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} />

      <Typography variant="muted">
        By registering I agree to the CPJ{" "}
        <span className="text-foreground-900 underline cursor-pointer relative z-10" onClick={handleOpenModal}>
          Terms of Use
        </span>
      </Typography>
    </>
  );
};

export default TermOfUseLabel;
